import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import http from "@/lib/api";
import Desktop from "@/pages/Desktop";
import Admin from "@/pages/Admin";

function Tracker() {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname.startsWith("/login") || location.pathname.startsWith("/admin")) return;
    let vid = localStorage.getItem("cs_vid");
    if (!vid) {
      vid = Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem("cs_vid", vid);
    }
    http.post("/analytics/track", { path: location.pathname, vid }).catch(() => {});
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <div className="App h-full">
      <BrowserRouter>
        <Tracker />
        <Routes>
          <Route path="/" element={<Desktop />} />
          <Route path="/login" element={<Admin />} />
          <Route path="/admin" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default App;
